import * as classNames from "classnames";
import * as React from "react";
import * as myClasses from "../";

import { HTMLDivProps, Text } from "@blueprintjs/core";
import { Classes, MPDButton } from "src/mpd-library/";

import './styles.css';

export interface IListSearchBarProps extends HTMLDivProps {
  searchBarText?: string;
  onSearchChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  onRightButtonClick?(event?: any): void;
  onToggleSearchBar?(event?: any): void;
  onLeftButtonClick?(event?: any): void;
}
export const ListSearchBar: React.SFC<IListSearchBarProps> = props => {
  const {
    className,
    onSearchChange,
    onRightButtonClick,
    onToggleSearchBar,
    onLeftButtonClick,
    searchBarText
  } = props;

  const classes = classNames(myClasses.LIST_SEARCHBAR_CONTAINER, className);

  return (
    <div className={classes}>
      <div className={Classes.LEFT}>
        <MPDButton
          className={myClasses.LIST_SIDEBAR_TOGGLE}
          onClick={onLeftButtonClick}
          name="content-view--header--toggle-menu"
        />
        <Text className={myClasses.LIST_SEARCHBAR_TEXT}>Alerts</Text>
      </div>
      <div className={Classes.RIGHT}>
        <MPDButton
          className={myClasses.LIST_SEARCHBAR}
          name="list-view--header--search"
          onClick={onToggleSearchBar}
        />
        <input
          className={myClasses.LIST_SEARCHBAR_INPUT}
          onChange={onSearchChange}
          value={searchBarText}
          placeholder="Search alerts"
        />
        <MPDButton
          className={myClasses.LIST_SEARCHBAR_EXIT}
          name="list-view--header--exit"
          onClick={onToggleSearchBar}
        />
        <MPDButton
          className={myClasses.LIST_SEARCHBAR_COMPOSE}
          name="list-view--header--new"
          onClick={onRightButtonClick}
        />
      </div>
    </div>
  );
};

export default ListSearchBar;



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/list-search-bar/list-search-bar.tsx